export const VERIFY_EMAIL_REQUEST = 'VERIFY_EMAIL_REQUEST';
export const VERIFY_EMAIL_SUCCESS = 'VERIFY_EMAIL_SUCCESS';
export const VERIFY_EMAIL_FAILURE = 'VERIFY_EMAIL_FAILURE';
export const RESEND_VERIFICATION_REQUEST = 'RESEND_VERIFICATION_REQUEST';
export const RESEND_VERIFICATION_SUCCESS = 'RESEND_VERIFICATION_SUCCESS';
export const RESEND_VERIFICATION_FAILURE = 'RESEND_VERIFICATION_FAILURE';

export interface VerifyEmailRequestAction {
  type: typeof VERIFY_EMAIL_REQUEST;
}

export interface VerifyEmailSuccessAction {
  type: typeof VERIFY_EMAIL_SUCCESS;
  payload: any;
}

export interface VerifyEmailFailureAction {
  type: typeof VERIFY_EMAIL_FAILURE;
  payload: string;
}

export interface ResendVerificationRequestAction {
  type: typeof RESEND_VERIFICATION_REQUEST;
}

export interface ResendVerificationSuccessAction {
  type: typeof RESEND_VERIFICATION_SUCCESS;
  payload: any;
}

export interface ResendVerificationFailureAction {
  type: typeof RESEND_VERIFICATION_FAILURE;
  payload: string;
}

export type EmailVerificationActionTypes =
  | VerifyEmailRequestAction
  | VerifyEmailSuccessAction
  | VerifyEmailFailureAction
  | ResendVerificationRequestAction
  | ResendVerificationSuccessAction
  | ResendVerificationFailureAction;